import { render } from "./SequenceHelp.vue?vue&type=template&id=6c084134&scoped=true"
import script from "./SequenceHelp.vue?vue&type=script&lang=js"
export * from "./SequenceHelp.vue?vue&type=script&lang=js"

import "./SequenceHelp.vue?vue&type=style&index=0&id=6c084134&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c084134"]])

export default __exports__